document.addEventListener('DOMContentLoaded', function () {
  const mobileMenu = document.getElementById('headerMobileMenu');
  const closeBtn = document.getElementById('closeMobileMenu');
  const sectionTitles = document.querySelectorAll('.header-mobile-menu__section-title');

  window.openMobileMenu = function () {
    mobileMenu.classList.add('active');
    document.body.style.overflow = 'hidden';
  };

  if (closeBtn) {
    closeBtn.addEventListener('click', function () {
      mobileMenu.classList.remove('active');
      document.body.style.overflow = '';
    });
  }

  // Expandir/Colapsar seções
  sectionTitles.forEach((title) => {
    title.addEventListener('click', function () {
      const sectionId = this.dataset.section;
      const items = document.getElementById(sectionId);

      this.classList.toggle('active');
      items.classList.toggle('active');
    });
  });

  // Dropdown do mega menu
  const dropdownTriggers = document.querySelectorAll('[data-dropdown-trigger]');
  dropdownTriggers.forEach((trigger) => {
    trigger.addEventListener('click', function () {
      const menu = this.nextElementSibling;
      if (menu && menu.hasAttribute('data-dropdown-menu')) {
        this.classList.toggle('active');
        menu.classList.toggle('active');
      }
    });
  });
});
